import React from "react"

import PCMAdminFollowUpPatient from "./PCMAdminFollowUpPatient"

const PCMFollowUpView = () => <PCMAdminFollowUpPatient isFromAddPatient />

export default PCMFollowUpView
